import React from "react";
import { LoginLogo } from "../../assets/svgs";
import "./pageLoader.css";

export const PageLoader = () => {
	return (
		<div className="page_loader_container">
			<div className="loader" />
			<LoginLogo className="top" />
		</div>
	);
};
